import React, { useState } from 'react'
import SelectCard from '../SelectCard'
import WorkGroupsContainer from '../WorkGroupsContainer'
import { useTranslation } from 'react-i18next'

const WorkGroupComponent = ({ results }) => {
  const [t] = useTranslation('translation', {
    keyPrefix: 'pages.data.dashBoardSociogram'
  })
  const [mediatorState, setMediatorState] = useState(true)
  const [newLinksState, setNewLinksState] = useState(false)
  const [preferencesState, setPreferencesState] = useState(false)
  const [selectWorkGroupButtonState, setSelectWorkGroupButtonState] =
    useState(4)
  // TODO: Refactor for 1 useState
  const handleShowMediatorsData = e => {
    e.stopPropagation()
    setMediatorState(true)
    setNewLinksState(false)
    setPreferencesState(false)
  }

  const handleShowNewLinksData = e => {
    e.stopPropagation()
    setMediatorState(false)
    setNewLinksState(true)
    setPreferencesState(false)
  }

  const handleShowPreferencesData = e => {
    e.stopPropagation()
    setMediatorState(false)
    setNewLinksState(false)
    setPreferencesState(true)
  }

  const dataGroups = results?.newGroups?.groups

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-evenly',
          marginBottom: '2rem'
        }}
      >
        <SelectCard
          handleClickCard={handleShowMediatorsData}
          indicatorState={mediatorState}
          title={t('mediators')}
          setSelectButtonState={setSelectWorkGroupButtonState}
        />
        <SelectCard
          handleClickCard={handleShowNewLinksData}
          indicatorState={newLinksState}
          title={t('newLinks')}
          setSelectButtonState={setSelectWorkGroupButtonState}
        />
        <SelectCard
          handleClickCard={handleShowPreferencesData}
          indicatorState={preferencesState}
          title={t('preferences')}
          setSelectButtonState={setSelectWorkGroupButtonState}
        />
      </div>
      <WorkGroupsContainer
        data={dataGroups}
        selectButtonState={selectWorkGroupButtonState}
        mediatorState={mediatorState}
        newLinksState={newLinksState}
        preferencesState={preferencesState}
      />
    </>
  )
}

export default WorkGroupComponent
